import React, { useState } from "react";

export default function PaymentSection({ 
  selectedPlan, 
  invoiceData = null,
  company
}) {
  const [cardName, setCardName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [acceptedContracts, setAcceptedContracts] = useState(false);

  if (!selectedPlan) {
    return (
      <div style={styles.emptyContainer}>
        <div style={styles.emptyIcon}>💳</div>
        <p style={styles.emptyText}>Ödeme yapabilmek için bir plan seçin.</p>
      </div>
    );
  }

  const isInvoiceValid = invoiceData?.isValid || false;
  const isFormValid = 
    cardName &&
    cardNumber.replace(/\s/g, "").length === 16 &&
    expiry.length === 5 &&
    cvv.length === 3 &&
    acceptedContracts &&
    isInvoiceValid &&
    company?.id;

  const handlePayment = async () => {
    if (!company?.id) {
      alert("Şirket bilgisi bulunamadı.");
      return;
    }

    const paymentData = {
      companyId: company.id,
      cardInfo: {
        cardName,
        cardNumber: cardNumber.replace(/\s/g, ""),
        expiry,
        cvv
      },
      invoiceInfo: invoiceData ? {
        email: invoiceData.email,
        address: invoiceData.address,
        phone: invoiceData.phone,
        companyName: invoiceData.companyName,
        taxNumber: invoiceData.taxNumber,
        taxCity: invoiceData.taxCity,
        taxOfficeName: invoiceData.taxOfficeName
      } : null,
      planInfo: {
        planId: selectedPlan.id,
        planName: selectedPlan.name,
        price: selectedPlan.price,
        durationDays: selectedPlan.durationDays
      },
      contractsAccepted: acceptedContracts,
      paymentDate: new Date().toISOString()
    };

    console.log("Gönderilen Ödeme Verisi:", paymentData);

    try {
      const response = await fetch(
        "https://us-central1-temeldencom.cloudfunctions.net/testPayment",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(paymentData),
        }
      );

      const result = await response.json();
      console.log("API Cevabı:", result);
      alert(result.message);
    } catch (err) {
      console.error(err);
      alert("Ödeme sırasında hata oluştu.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>Güvenli Ödeme</h2>
        <div style={styles.secureBadge}>
          <span style={styles.lockIcon}>🔒</span>
          <span>256-bit SSL</span>
        </div>
      </div>

      {/* PLAN ÖZETİ */}
      <div style={styles.summary}>
        <div style={styles.summaryHeader}>
          <span style={styles.summaryTitle}>Plan Özeti</span>
        </div>

        <div style={styles.summaryContent}>
          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>Plan:</span>
            <span style={styles.summaryValue}>{selectedPlan.name}</span>
          </div>

          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>Süre:</span>
            <span style={styles.summaryValue}>
              {selectedPlan.durationDays} gün
            </span>
          </div>

          {/* ✅ YENİ EKLENEN SATIR */}
          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>Proje Limiti:</span>
            <span style={styles.summaryValue}>
              {selectedPlan.features.projectLimit === -1
                ? "Sınırsız"
                : selectedPlan.features.projectLimit}
            </span>
          </div>

          <div style={styles.summaryDivider}></div>

          <div style={styles.summaryRow}>
            <span style={styles.summaryLabel}>Toplam Tutar:</span>
            <span style={styles.summaryPrice}>
              ₺{selectedPlan.price}
            </span>
          </div>
        </div>
      </div>


      {/* KART BİLGİLERİ */}
      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>Kart Bilgileri</h3>
        <div style={styles.form}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>Kart Üzerindeki İsim</label>
            <input
              style={styles.input}
              type="text"
              value={cardName}
              onChange={(e) => setCardName(e.target.value)}
              placeholder="Ad Soyad"
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Kart Numarası</label>
            <input
              style={styles.input}
              type="text"
              value={cardNumber}
              onChange={(e) =>
                setCardNumber(
                  e.target.value
                    .replace(/\D/g, "")
                    .replace(/(.{4})/g, "$1 ")
                    .trim()
                )
              }
              maxLength={19}
              placeholder="1234 5678 9012 3456"
            />
          </div>

          <div style={styles.row}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Son Kullanma Tarihi</label>
              <input
                style={styles.input}
                type="text"
                value={expiry}
                onChange={(e) =>
                  setExpiry(
                    e.target.value
                      .replace(/\D/g, "")
                      .replace(/(.{2})/, "$1/")
                      .substring(0, 5)
                  )
                }
                placeholder="AA/YY"
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>
                CVV
                <span style={styles.infoIcon} title="Kartınızın arkasındaki 3 haneli numara">?</span>
              </label>
              <input
                style={styles.input}
                type="password"
                value={cvv}
                onChange={(e) =>
                  setCvv(e.target.value.replace(/\D/g, "").substring(0, 3))
                }
                placeholder="***"
              />
            </div>
          </div>
        </div>
      </div>

      {/* SÖZLEŞMELER */}
      <div style={styles.contractsSection}>
        <h3 style={styles.sectionTitle}>Sözleşmeler</h3>
        <div style={styles.contracts}>
          <label style={styles.checkbox}>
            <input
              type="checkbox"
              checked={acceptedContracts}
              onChange={() => setAcceptedContracts(!acceptedContracts)}
              style={styles.checkboxInput}
            />
            <div style={acceptedContracts ? styles.checkboxChecked : styles.checkboxUnchecked}>
              {acceptedContracts && <span style={styles.checkmark}>✓</span>}
            </div>
            <span style={styles.contractText}>
              <a href="/kvkk" target="_blank" style={styles.contractLink}>KVKK Aydınlatma Metni</a>,{" "}
              <a href="/on-bilgilendirme" target="_blank" style={styles.contractLink}>Ön Bilgilendirme Formu</a>{" "}
              ve{" "}
              <a href="/mesafeli-satis" target="_blank" style={styles.contractLink}>
                Mesafeli Satış Sözleşmesi
              </a>
              'ni okudum, kabul ediyorum.
            </span>
          </label>
        </div>
      </div>

      {!isInvoiceValid && (
        <div style={styles.invoiceWarning}>
          <span style={styles.warningIcon}>⚠</span>
          <span>Fatura bilgilerini tamamlamadan ödeme yapamazsınız</span>
        </div>
      )}

      <button
        style={{
          ...styles.payBtn,
          ...(isFormValid ? styles.payBtnActive : styles.payBtnDisabled),
        }}
        disabled={!isFormValid}
        onClick={handlePayment}
      >
        <span style={styles.payBtnText}>Güvenli Ödeme Yap</span>
      </button>

      <div style={styles.footerNote}>
        <p style={styles.footerText}>
          Ödeme işleminiz 256-bit SSL şifreleme ile korunmaktadır. 
          Kart bilgileriniz hiçbir şekilde saklanmamaktadır.
        </p>
      </div>
    </div>
  );
}

/* STYLES - PaymentSection */
const styles = {
  container: { backgroundColor: "#FFFFFF", borderRadius: "8px", border: "1px solid #E5E7EB", padding: "24px" },
  emptyContainer: { backgroundColor: "#FFFFFF", padding: "48px 24px", borderRadius: "8px", textAlign: "center", border: "1px dashed #E5E7EB" },
  emptyIcon: { fontSize: "40px", marginBottom: "12px", opacity: 0.5 },
  emptyText: { fontSize: "14px", color: "#6B7280", margin: "0" },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px", paddingBottom: "16px", borderBottom: "1px solid #E5E7EB" },
  title: { fontSize: "18px", fontWeight: "600", color: "#111827", margin: "0" },
  secureBadge: { display: "flex", alignItems: "center", gap: "6px", backgroundColor: "#F0F9FF", color: "#0369A1", padding: "6px 12px", borderRadius: "4px", fontSize: "12px", fontWeight: "500" },
  lockIcon: { fontSize: "12px" },
  summary: { backgroundColor: "#F9FAFB", borderRadius: "6px", padding: "20px", marginBottom: "24px", border: "1px solid #E5E7EB" },
  summaryHeader: { marginBottom: "16px" },
  summaryTitle: { fontSize: "16px", fontWeight: "600", color: "#374151" },
  summaryContent: { display: "flex", flexDirection: "column", gap: "12px" },
  summaryRow: { display: "flex", justifyContent: "space-between", alignItems: "center" },
  summaryLabel: { fontSize: "14px", color: "#6B7280" },
  summaryValue: { fontSize: "14px", fontWeight: "500", color: "#374151" },
  summaryDivider: { height: "1px", backgroundColor: "#E5E7EB", margin: "4px 0" },
  summaryPrice: { fontSize: "20px", fontWeight: "700", color: "#111827" },
  section: { marginBottom: "24px" },
  sectionTitle: { fontSize: "16px", fontWeight: "600", color: "#374151", margin: "0 0 16px 0" },
  form: { display: "flex", flexDirection: "column", gap: "16px" },
  row: { display: "flex", gap: "16px" },
  inputGroup: { display: "flex", flexDirection: "column", gap: "8px", flex: 1 },
  label: { fontSize: "14px", fontWeight: "500", color: "#374151", display: "flex", alignItems: "center", gap: "6px" },
  input: { padding: "12px 16px", fontSize: "14px", borderRadius: "6px", border: "1px solid #D1D5DB", backgroundColor: "#FFFFFF", color: "#111827", transition: "border-color 0.2s" },
  infoIcon: { width: "16px", height: "16px", borderRadius: "50%", backgroundColor: "#E5E7EB", color: "#6B7280", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "10px", fontWeight: "bold", cursor: "help" },
  contractsSection: { marginBottom: "24px" },
  contracts: { backgroundColor: "#F9FAFB", borderRadius: "6px", padding: "20px", border: "1px solid #E5E7EB" },
  checkbox: { display: "flex", gap: "12px", alignItems: "flex-start", cursor: "pointer" },
  checkboxInput: { display: "none" },
  checkboxUnchecked: { width: "20px", height: "20px", borderRadius: "4px", border: "2px solid #D1D5DB", backgroundColor: "#FFFFFF", flexShrink: 0, marginTop: "2px" },
  checkboxChecked: { width: "20px", height: "20px", borderRadius: "4px", border: "2px solid #059669", backgroundColor: "#059669", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "2px" },
  checkmark: { color: "#FFFFFF", fontSize: "12px", fontWeight: "bold" },
  contractText: { fontSize: "13px", color: "#4B5563", lineHeight: "1.5" },
  contractLink: { color: "#2563EB", textDecoration: "none", fontWeight: "500" },
  invoiceWarning: { backgroundColor: "#FEF3C7", border: "1px solid #F59E0B", borderRadius: "6px", padding: "12px 16px", marginBottom: "16px", display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", color: "#92400E" },
  warningIcon: { fontSize: "16px" },
  payBtn: { width: "100%", padding: "16px", border: "none", borderRadius: "6px", fontSize: "16px", fontWeight: "600", cursor: "pointer", transition: "background-color 0.2s", marginBottom: "16px" },
  payBtnActive: { backgroundColor: "#059669", color: "#FFFFFF" },
  payBtnDisabled: { backgroundColor: "#E5E7EB", color: "#9CA3AF", cursor: "not-allowed" },
  payBtnText: { fontSize: "16px", fontWeight: "600" },
  footerNote: { textAlign: "center", paddingTop: "16px", borderTop: "1px solid #E5E7EB" },
  footerText: { fontSize: "12px", color: "#6B7280", lineHeight: "1.5", margin: "0" },
};
